import Vue from "vue";
import App from "./App.vue";
import accounting from 'accounting'

import {registerAllModules} from 'handsontable/registry';
// register all Handsontable modules
registerAllModules();

// Import du service worker
//import { registerServiceWorker } from '../public/register-sw';

Vue.config.productionTip = false;

// Enregistrer le service worker (gestion du cache et des mises à jour)
//registerServiceWorker();

import logoutPlugin from 'vue-auto-logout'

const logoutOptions = {
    stagnateTime: 180 * 60 * 1000,
    detectTime: 30 * 60 * 1000
}
Vue.use(logoutPlugin, logoutOptions)

import * as VueGoogleMaps from "vue2-google-maps" // Import package
Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBuaqS0dSmzP8-tZs2o-RIthGW6zxnLvbI",
        libraries: "places",
        region: 'SN',
        language: 'fr',
    }
});

import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont";
import pluralize from 'pluralize'
import ProgressBar from 'vuejs-progress-bar'
import router from "./router/index.js";
import {store} from "@/store/index.js";

import {initialize} from "./helper/general";

import VueNumber from "vue-number-animation";
Vue.use(VueNumber);

import VModal from 'vue-js-modal'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Popover from 'vue-js-popover'
import VueFileAgent from 'vue-file-agent';
//csv
import JsonCSV from "vue-json-csv";
//vue-json-pretty
import VueJsonPretty from "vue-json-pretty";
// Confirm dialog
import VuejsDialog from 'vuejs-dialog';
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
// apexcharts
import VueApexCharts from "vue-apexcharts";
// Vue mobile
// import VueMobileDetection from "vue-mobile-detection";
//Vue moment
import moment from "moment"
import Datetime from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Vuelidate from "vuelidate";
//licence dialog date
import EditLicenceDate from "./components/User/Crud/EditLicenceDateDialog.vue";

Vue.component('downloadCsv', JsonCSV)

Vue.use(ProgressBar)

Vue.use(VModal, {
    dynamic: true,
    dialog: true,
    dynamicDefaults: {
        draggable: true,
        resizable: true,
        height: 'auto'
    }
})

Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
});

// Dans votre composant ou main.js
window.addEventListener('error', e => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
    }
});

Vue.use(Popover, {tooltip: true})

initialize(store, router);


Vue.use(VueFileAgent);

Vue.component("downloadCsv", JsonCSV);

Vue.component("VueJsonPretty", VueJsonPretty);

require("vue-simple-calendar/static/css/default.css")
require("vue-simple-calendar/static/css/holidays-us.css")

// Tell Vue to install the plugin.
Vue.use(VuejsDialog, {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    okText: 'Confirmer',
    cancelText: 'Annuler',
    animation: 'bounce', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
    clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
    backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
    customClass: '' // Custom class to be injected into the parent node for the current dialog instance
});


import VueModalTor from "vue-modaltor/dist/vue-modaltor.common.js"
import "vue-modaltor/dist/vue-modaltor.css"

Vue.use(VueModalTor)

import VueDeviceDetector from 'vue-device-detector';

Vue.use(VueDeviceDetector);

import {vfmPlugin} from 'vue-final-modal'

Vue.use(vfmPlugin)

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

// Vue.use(VueMobileDetection)

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(value).format('DD-MM-YYYY HH:mm:ss');
    }
});

Vue.filter('formatDateEng', function (value) {
    if (value) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss');
    }
});

Vue.filter('pluralize', function (value, number) {
    return pluralize(value, number)
})

Vue.use(Datetime);

// Vue.use(VueMobileDetection)

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.use(Vuelidate);

Vue.component("edit-licence-date-dialog", EditLicenceDate);

Vue.config.productionTip = false;

Vue.filter('formatMoney', accounting.formatMoney)
Vue.filter('pluralize', pluralize)

new Vue({
    vuetify,
    router,
    store,
    created() {
        //if user
        const token = sessionStorage.getItem("token");
        const role = sessionStorage.getItem("userRole");
        const baseUrl = sessionStorage.getItem("baseUrl");
        const obj = {
            token: token,
            role: role,
            baseUrl: baseUrl
        };
        if (token) {
            this.$store.dispatch("autoLogin", obj);
        }
    },

    render: h => h(App)
}).$mount("#app");
